export default __webpack_public_path__ + "static/media/printer.ed6f2b35.png";